import React from 'react';
import Modal from '../modal/Modal';
import LeagueForm from './form';
import AcceptModal from "../accept_modal/AcceptModal";
import SearchForm from "../searchForm/SearchForm";
import { toast } from "react-toastify";
import LeaguesApi from "../../api/Leagues";
import TournamentsApi from "../../api/Tournaments";

export default class Leagues extends React.Component{
    leagues = [];
    tournaments = [];
    constructor(){
        super();
        this.state = {
            showModal: false,
            data: [],
            modalTitle: "",
            selected: null,
            showAcceptModal: false,
            filterText: ""
        };
    }

    componentWillMount(){
        LeaguesApi.getAll().then(r => {
            let st = {...this.state};
            st.data = r.data.response
            this.setState(st);
            this.leagues = r.data.response;
        });
        TournamentsApi.getAll().then(r => {
            this.tournaments = r.data.response;
        }).catch(err => toast.warn('Atención, Agregue un torneo para generar una liga'));

    }


    edit(league){
        let st = this.state
        st.modalTitle = "Editar";
        st.showModal = true;
        st.selected = league;
        this.setState(st);
    }

    closeModal(){
        let st =this.state;
        st.showModal = false;
        this.setState(st);
    }

    save(league){
        let state = {...this.state};
        if(!league.id){
            league.status = 2;
            LeaguesApi.create(league).then(res => {
                state.data.push(res.data.response);
                this.setState(state);
                toast.success("La liga se guardó correctamente");
            }).catch(err => console.log(err));
        }else{
            console.log("res")
            LeaguesApi.edit(league, league.id).then(res => {
                console.log(res)
                state.data[state.data.findIndex(t => t.id === league.id)] = league;
                state.selected = null;
                this.setState(state);
                toast.success("Datos actualizados");
            })
        }
        this.leagues = state.data
        state.showModal = false;
    }

    create(){
        let st = this.state
        st.modalTitle = "Nuevo";
        st.showModal = true;
        st.selected = null;
        this.setState(st);
    }

    remove(){
        LeaguesApi.delete(this.state.selected.id).then(res => {
            if(res.data.response){
                let state = {...this.state};
                state.data.splice(state.data.findIndex(t => t.id === state.selected.id),1);
                state.selected = null;
                state.showAcceptModal = false;
                this.setState(state);
                toast.success("Liga eliminada");
            }else{
                toast.error('Ocurrió un problema, intente más tarde');
            }
        })
    }

    delete(league){
        let state = {...this.state};
        state.showAcceptModal = true;
        state.selected = league;
        this.setState(state);
    }

    handleSearchInput(text){
        let leagues = this.leagues.filter(league => league.tournament_name.toLowerCase().includes(text.toLowerCase())||league.name.toLowerCase().includes(text.toLowerCase()));
        let state = this.state;
        state.filterText = text;
        state.data = leagues;
        this.setState(state);
    }

    render(){
        return(
            <div className="card-content">
                <div className="columns">
                    <div className="column">
                        <div className="field">
                            <div className="control">
                                <SearchForm
                                    filterText={this.state.filterText}
                                    onInput={(t) => this.handleSearchInput(t)}
                                    itemName={'liga'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="field">
                            <div className="control">
                                <a className="button is-outlined is-primary" onClick={(e) => this.create()}>Agregar liga</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="columns">
                    <div className="column">
                        <table className="table is-fullwidth">
                            <thead>
                            <tr>
                                <th>Id</th>
                                <th>Liga</th>
                                <th>Torneo</th>
                                <th>Tipo de Torneo</th>
                                <th>Estatus</th>
                                <th>Acciones</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.data.map(d => {
                                return(
                                    <tr key={d.id}>
                                        <th>{d.id}</th>
                                        <td><a href="#" title={d.name}>{d.name}</a></td>
                                        <td>{d.tournament_name}</td>
                                        <td>{(d.tournament=="fut7"? "Fútbol 7":"Fútbol rápido")}</td>
                                        <td>
                                            <div className="field" >
                                                <input
                                                    id={d.id}
                                                    type="checkbox"
                                                    name="status"
                                                    className="switch"
                                                    checked={parseInt(d.status) === 1}
                                                    onChange={() => {}}
                                                />
                                                <label htmlFor="status" onClick={() => {
                                                    d.status = parseInt(d.status) === 1 ? 2 : 1;
                                                    this.save(d);
                                                }}/>
                                            </div>
                                        </td>
                                        <td>
                                            <a className="button is-warning" onClick={(e) => this.edit(d)}>
                                                <span className="icon is-small">
                                                    <i className="fas fa-edit"/>
                                                </span>
                                            </a>
                                            <a className="button is-danger" onClick={(e) => this.delete(d)}>
                                                <span className="icon is-small">
                                                    <i className="fas fa-trash"/>
                                                </span>
                                            </a>
                                        </td>
                                    </tr>

                                )
                            })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
                {this.state.showModal &&
                <Modal
                    showModal={this.state.showModal}
                    modalTitle={this.state.modalTitle}
                    data = {this.state.data}
                    cancel={() => this.closeModal()}
                >
                    <LeagueForm
                        selected = { this.state.selected }
                        cancel={() => this.closeModal()}
                        save={(t)=>this.save(t)}
                        tournaments={this.tournaments}
                    />
                </Modal>
                }

                {this.state.showAcceptModal &&
                <AcceptModal
                    isActive={this.state.showAcceptModal}
                    done={(t) => this.remove(t)}
                    cancel={() => {
                        let state = {...this.state};
                        state.showAcceptModal = false;
                        this.setState(state);
                    }}
                    modalTitle={"Eliminar liga"}
                />
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/league/League.js